import { Injectable } from "@angular/core";
import { Config } from "./config";
import { environment } from "../../environments/environment";
import { Observable, Subject, Subscription } from "../../../node_modules/rxjs";
import { map } from "rxjs/operators";
import { Constants } from '../util/const/constants';
import { Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
// import { error } from "console";


@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  constructor(private http: Http, private router: Router) { }
  alertMessageOccured = new Subject<any>();
  configs: Config[] = [];
  subscription: Subscription;
  server_url = environment.server_URL;
  keycloakInstance :any;
  idToken :any;
  authType : any;
  
  getConfigByName(configName:string, setLocalStorage:boolean ) {
    console.log("[AuthenticationService]:: getConfigByName()::configName=>" + configName);
    const body = JSON.stringify({ 'configName': configName});
    const headers = new Headers({ 'Content-Type': 'application/json' });
    
   this.http.post(environment.server_URL + '/config/getConfigByName', body, { headers:headers })
    // .map(res => res.json());
    .subscribe(
        (data: any) => {
            console.log("[AuthenticationService]:: getConfigByName()::data =>", JSON.stringify(data.json().configValues.ConfigValue));

            if (setLocalStorage) {
              localStorage.setItem(configName, JSON.stringify(data.json().configValues.ConfigValue));
            }
        },
        (error) => {
            console.error("[AuthenticationService]:: getConfigByName()::error =>", error);
        }
    );

  }

  

  // getAllConfigs() {
   
  //   let headers: HttpHeaders = new HttpHeaders()
  //   this.http.post<any>(
  //     environment.server_URL + "/config/getAllConfigs",
  //     {
  //       headers: headers
  //     }
  //   ).subscribe((response) => {
  //     return response;
  //   });
  // }

  setKeycloakInstance(keycloakInst: any): void {
    this.keycloakInstance = keycloakInst;
  }

  getKeycloakInstance(): any {
    return this.keycloakInstance;
  }

  setKeycloakInstanceIdToken(idToken: any): void {
    this.idToken = idToken;
  }

  getKeycloakInstanceIdToken(): any {
    return this.idToken;
  }
  
  setAuthType(authType: any): void {
    this.authType = authType;
  }

  getAuthType(): any {
    return this.authType;
  }


}
